<template>
  <div class="statisticDetail">
    <topBar :title="$t('newSurvey.statistic')" />
    <div class="commonContainer" style="margin-top: 0px !important;">
      <div class="title"> {{ title }}
        <el-button size="mini" type="primary" class="back" @click="backList">返回</el-button>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="默认报告" name="first">
          <div style="width: 100%;position: relative;">

            <div class="box-card">
              <div class="statisticResult">
                <el-row>
                  <el-col :span="4">
                    <div class="box-item first">
                      <div class="title">问卷提交数</div>
                      <div class="box-count">{{ searchResult.submitCount }}
                      </div>
                      <div class="box-label" style="margin-top: 170px;">全国</div>
                      <el-button round style="margin-top: 10px;" v-show="searchResult.regions.length>0"
                        @click="showDialog(null, searchResult.submitCount, '全国')">查看客户统计</el-button>
                    </div>
                  </el-col>
                  <el-col :span="4" v-for="index in 4 " :key="'region-'+index">
                    <div class="box-item" v-if="searchResult.regions[index-1]&&searchResult.regions[index-1].label">
                      <el-progress style="margin-top: 30px;" type="circle"
                        :percentage="searchResult.regions[index-1].count / searchResult.submitCount * 100" :show-text="false" :width="120"
                        :stroke-width="15" color="#67c23a" stroke-linecap="butt"></el-progress>
                      <div class="box-count">{{ searchResult.regions[index-1].count }}</div>
                      <div class="box-label" style="margin-top: 15px;">{{ searchResult.regions[index-1].label }}</div>
                      <el-button round style="margin-top: 10px;"
                        @click="showDialog(searchResult.regions[index-1].no, searchResult.regions[index-1].count, searchResult.regions[index-1].label)">查看区域客户统计</el-button>
                    </div>
                    <div class="box-item" v-else>

                    </div>
                  </el-col>
                  <el-col :span="4" v-if="searchResult.showScore">
                    <div class="box-item last">
                      <div class="box-count">{{ searchResult.score }}
                      </div>
                      <div class="box-label" style="margin-top: 170px;">问卷分数</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>

            <div class="box-card" style="margin-top: 20px !important;">
              <div>筛选题目统计<i class="el-icon-edit-outline"></i></div>
              <div class="filterConditionContainer">
                <el-form v-show="options.regions.length > 0">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="区域：">
                        <el-select size="mini" v-model="form.filter.regionNos" multiple
                          :placeholder="$t('filters.chooseRegion')" @visible-change="resetFilters()"
                          class="filterSelect">
                          <el-option v-for="item in options.regions" :key="item.itemValue" :label="item.itemLabel"
                            :value="item.itemValue">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="省份：">
                        <el-select size="mini" v-model="form.filter.provinceNos" multiple
                          :placeholder="$t('filters.chooseProvince')" @visible-change="resetFilters()"
                          class="filterSelect">
                          <el-option v-for="item in options.provinces" :key="item.itemValue" :label="item.itemLabel"
                            :value="item.itemValue">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="城市：">
                        <el-select size="mini" v-model="form.filter.cityNos" multiple
                          :placeholder="$t('filters.chooseCity')" @visible-change="resetFilters()" class="filterSelect">
                          <el-option v-for="item in options.cities" :key="item.itemValue" :label="item.itemLabel"
                            :value="item.itemValue">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="客户：">
                        <el-select size="mini" v-model="form.filter.resellerNos" multiple
                          :placeholder="$t('filters.chooseReseller')" @visible-change="resetFilters()"
                          class="filterSelect">
                          <el-option v-for="item in options.resellers" :key="item.itemValue" :label="item.itemLabel"
                            :value="item.itemValue">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="门店：">
                        <span @click="onChooseDoor" style="width: 45%;display: inline-flex;">
                          <el-input v-model="doorName" size="mini" :placeholder="$t('filters.chooseDoorName')"
                            class="filterSelect">
                          </el-input>
                        </span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <el-row v-show="options.regions.length > 0">
                  <el-divider></el-divider>
                </el-row>
                <el-form label-position="top">
                  <el-row :gutter="20">
                    <el-col v-if="options.questions.length > 0" :span="12" v-for="item in options.questions"
                      :key="'questions-' + item.id">
                      <el-form-item size="mini" :label="item.sort + '.' + item.name">
                        <el-select v-if="item.type == 3" size="mini" :placeholder="'请选择筛选项'"
                          v-model="questions[item.id].score" style="width:100%" class="filterSelect" multiple>
                          <el-option v-for="item2 in item.maxScore + 1" :key="'item-' + item2" :label="(item2 - 1)==0?item.leftLabel:(item2 - 1)==item.maxScore?item.rightLabel:(item2 - 1)"
                            :value="(item2 - 1)==0?item.leftLabel:(item2 - 1)==item.maxScore?item.rightLabel:(item2 - 1)">
                          </el-option>
                        </el-select>

                        <el-select v-else size="mini" multiple :placeholder="'请选择筛选项'"
                          v-model="questions[item.id].itemId" style="width:100%" class="filterSelect" >
                          <el-option v-for="item3 in item.items" :key="'item-' + item3.id" :label="item3.content"
                            :value="item3.id">
                          </el-option>

                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>

                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-col :span="8">
                    <div class="filterBtns">
                      <el-button type="primary" size='mini' @click="onSearchDetail">{{ $t('search') }}</el-button>
                      <el-button type="primary" size='mini' @click="resetFilters(true)">{{ $t('reset') }}</el-button>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>


            <div class="defaultContainer" v-for="item in statisticList" :key="'list-' + item.id">
              <div style="width:100%;margin-bottom: 5px;">{{ item.sort + '.' + item.name }}</div>
              <el-button v-if="item.type == 5" @click="onDialogSearch(item)">查看详细信息</el-button>
              <div v-else-if="item.type == 4" style="width: 100%">
                <el-table :data="item.items" border style="width: 100%">
                  <el-table-column prop="sort" label="序号" width="50">
                  </el-table-column>
                  <el-table-column prop="content" label="答案文本">
                  </el-table-column>
                </el-table>
                <div style="position: relative;height: 28px;width: 100%;"><el-button
                    style="position: absolute;right:10px" size="mini" type="text"
                    @click="onDialogSearch(item)">查看全部</el-button></div>
              </div>
              <div v-else style="width: 100%">
                <el-table :data="item.items" border style="width: 100%" sortable  :row-class-name="tableRowClassName">
                  <el-table-column prop="content" label="选项">
                  </el-table-column>
                  <el-table-column prop="count" label="小计" width="80" sortable>
                  </el-table-column>
                  <el-table-column prop="percent" label="占比" width="720" sortable>
                    <template slot-scope="scope"> 
                      <el-progress :percentage="Number(scope.row.percent.replace('%',''))" :color="'#409eff'"></el-progress>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="box-card" style="padding: 50px 10px;">
                  <div style="width: 100%;text-align: center;">
                    <div :id="'chart' + item.id" style="height: 360px;"></div>
                  </div>
                  <div class="chart-btn top">
                    <div class="before" :active="item.chartType == 1" @click="renderDefault(item, 1, item.displayType)">
                      <i class="el-icon-pie-chart"></i>饼图</div>
                    <div :active="item.chartType == 2" @click="renderDefault(item, 2, item.displayType)"><i
                        class="el-icon-s-data"></i>柱状图</div>
                  </div>
                  <div class="chart-btn bottom">
                    <div class="before" :active="item.displayType == 1" @click="renderDefault(item, item.chartType, 1)">
                      百分比</div>
                    <div :active="item.displayType == 2" @click="renderDefault(item, item.chartType, 2)">数值</div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </el-tab-pane>
        <el-tab-pane label="对比分析" name="second">
          <div class="box-card" style="font-size: 16px;">
            <el-form>
              <el-row>
                <el-col :span="24">
                  请选择对比项目X
                </el-col>
                <el-col :span="12">
                  <el-form-item label="题目：">
                    <el-select size="mini" v-model="compareForm.elementX" clearable placeholder="请选择对比项目X"
                      style="width: 80%;">
                      <el-option
                        v-for="item in compareForm.elementY ? options.questions.filter(q => q.id != compareForm.elementY) : options.questions"
                        :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select></el-form-item>
                </el-col>
                <el-col :span="12">
                </el-col>
                <el-col :span="24">
                </el-col>
                <el-col :span="24">
                  请选择对比项目Y
                </el-col>
                <el-col :span="12">
                  <el-form-item label="题目：">
                    <el-select size="mini" v-model="compareForm.elementY" clearable placeholder="请选择对比项目Y"
                      style="width: 80%;">
                      <el-option :key="-1" :label="'区域对比'" :value="-1" v-if="options.regions.length>0">
                      </el-option>
                      <el-option :key="0" :label="'门店对比'" :value="0" @click="onChooseDoor" v-if="options.regions.length>0">
                        <el-button type="text" style="width:100%; text-align: justify;color: black;" @click="onChooseDoor">门店对比</el-button>
                      </el-option>
                      <el-option
                        v-for="item in compareForm.elementX ? options.questions.filter(q => q.id != compareForm.elementX) : options.questions"
                        :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select></el-form-item>
                </el-col>
                <el-col :span="12">
                </el-col>
              </el-row>
            </el-form>
            <el-row>
              <div style="width: 100%;color: #67c23a;">{{ doorName }}</div>
            </el-row>
            <el-row type="flex" class="row-bg" justify="space-between" style="margin-top: 10px;">
              <el-col :span="8">
                <div class="filterBtns">
                  <el-button type="primary" size='mini' @click="onSearchCompare">对比分析</el-button>
                  <el-button type="primary" size='mini' @click="resetFilters(true)">{{ $t('reset') }}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="box-card" style="font-size: 16px; margin-top: 10px;">
            <el-table :data="compareData" ref="table2" border>
              <el-table-column prop="content" label="X/Y">
              </el-table-column>
              <el-table-column v-for="(expand, index) in extendItem" :key="'Filed-' + index" :label="expand.content"
                width="200">
                <template slot-scope="scope">
                  {{ scope.row.defaultItems[index].count + "(" + scope.row.defaultItems[index].percent + ")" }}
                </template>
              </el-table-column>
              <el-table-column prop="count" label="小计" width="50">
              </el-table-column>
            </el-table>
          </div>
          <div class="box-card">
            <div :id="'compareChart'" style="padding-bottom: 50px;"></div>
            <div class="chart-btn bottom">
              <div class="before" :active="compareData[0] && compareData[0].displayType == 1" @click="renderCompare(1)">
                百分比</div>
              <div :active="compareData[0] && compareData[0].displayType == 2" @click="renderCompare(2)">数值</div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :title="clickLabel + '客户提交数'" :visible.sync="showFlag" width="778px" center>
      <div style="width: 100%;min-height: 600px;height: fit-content;">
        <el-col :span="5" v-for="item in subReseller" :key="item.no">
          <div class="box-item">
            <el-progress type="circle" :percentage="item.count / clickSum * 100" :show-text="false" :width="120"
              :stroke-width="15" color="#67c23a" stroke-linecap="square"></el-progress>
            <div class="box-count">{{ item.count }}</div>
            <div class="box-label" style="margin-top: 15px;">{{ item.label }}</div>
          </div>
        </el-col>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="showDialogFlag" width="778px" left>
      <div style="width: 100%;min-height: 600px;height: fit-content;">
        <div>{{ questionTitle }}</div>
        <el-table :data="tableData" border style="width: 100%;margin-top: 5px;">
          <el-table-column prop="sort" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="content" label="答案文本">
          </el-table-column>
        </el-table>
        <div style="position: relative;width: 100%;margin-top: 10px;">
          <el-pagination style="position: absolute;right:10px" background @current-change="currentChange"
            :current-page="table.page" layout="total, prev, pager, next, jumper" :total="table.total">
          </el-pagination>
        </div>

      </div>
    </el-dialog>
    <pickDoor2 v-model="form.posIdStr"
      :statisticFilter="{ id: initFilterForm.id, ...form.filter, reportStartTime: dateFilter.length == 2 ? dateFilter[0] : null, reportEndTime: dateFilter.length == 2 ? dateFilter[1] : null }"
      :url="'doors/inputSearch'" @on-confirm="pickConfirm" ref='PickDoor' />
  </div>

</template>
<script>
import { Chart } from "@antv/g2";
import DataSet from "@antv/data-set";
import TopBar from "../components/TopBar.vue";
import pickDoor2 from "../components/pickDoor2";
export default {
  name: "StatisticReport",
  components: {
    topBar: TopBar,
    pickDoor2,
    Chart
  },
  data() {
    return {
      title: "",
      dateFilter: this.$route.query.startTime
        ? [this.$route.query.startTime, this.$route.query.endTime]
        : [],
      filterForm: {},
      initFilterForm: {
        id: Number(this.$route.query.id || 0),
        date: this.$route.query.startTime
          ? [this.$route.query.startTime, this.$route.query.endTime]
          : []
      },
      form: {
        posIdStr: "",
        filter: {
          regionNos: [],
          provinceNos: [],
          cityNos: [],
          resellerNos: []
        }
      },
      questions: {},
      options: {
        regions: [],
        provinces: [],
        cities: [],
        resellers: [],
        questions: []
      },
      doorName: "",
      compareForm: {
        elementX: null,
        elementY: null
      },
      searchResult: {
        questionnaireCount: 0,
        submitCount: 0,
        showScore: false,
        score: 0,
        regions: [],
        resellers: []
      }, // 表格数据
      statisticList: [],
      subReseller: [],
      activeName: "first",
      showFlag: false,
      clickSum: 0,
      clickLabel: "",
      showDialogFlag: false,
      dialogType: 1, // 1信息收集 2 填空
      dialogTitle: "",
      questionId: 0,
      questionTitle: "",
      table: {
        page: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      compareData: [],
      extendItem: [],
      doors: [],
      chartStorage: {}
    };
  },
  computed: {
    posIds() {
      console.log("posIds",this.form.posIdStr)
      return this.form.posIdStr ? this.form.posIdStr.split(",").filter(i => i != "") : [];
    }
  },
  watch: {
    "compareForm.elementY": function() {
      this.posIdStr = "";
      this.doorName = "";
      this.doors = [];
    },
    showDialogFlag: function() {
      // console.log("AAAAA");
      this.table.page = 1;
    }
  },
  async mounted() {
    this.title = this.$route.query.name || "";
    await this.resetFilters();
    await this.onSearch();
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      let target = Object.keys(this.questions);
      if (target.length == 0) return;
      let check = false;

      if (
        this.questions[row.questionId] &&
        this.questions[row.questionId].itemId.length > 0
      ) {
        // console.log(this.questions)
        check =
          this.questions[row.questionId].itemId
            .map(i => i + "")
            .indexOf(row.id) > -1;
      }
      if (
        this.questions[row.questionId] &&
        this.questions[row.questionId].score.length > 0
      ) {
        check =
          this.questions[row.questionId].score
            .map(s => s + "")
            .indexOf(row.content) > -1;
      }
      if (check) {
        return "filter-row";
      }
      return "";
    },
    pickConfirm(data) {
      // console.log(doorName)
      this.doorName = data.doorName;
      this.doors = data.doors;
    },
    handleClick: function(tab, event) {
      // console.log(tab, event);
      // console.log(this.activeName);
      this.posIdStr = "";
      this.doorName = "";
      this.doors = [];
    },
    onSearch: async function(no) {
      this.subReseller = [];
      this.searchResult = {
        questionnaireCount: 0,
        submitCount: 0,
        regions: [],
        resellers: []
      };
      let ruleForm = {
        start: this.dateFilter.length == 2 ? this.dateFilter[0] : null,
        end: this.dateFilter.length == 2 ? this.dateFilter[1] : null,
        no: no ? no : null,
        id: this.initFilterForm.id
      };
      let { data } = await window.instance.post(
        openSurveyReqUrl + "statistic/detail",
        ruleForm
      );
      this.searchResult = data.data;
      this.searchResult.regions = this.searchResult.regions.filter(a=>a.label)
    },
    onReset: function() {
      this.dateFilter = [];
    },
    showDialog: async function(no, count, label) {
      this.subReseller = [];
      let ruleForm = {
        start: this.dateFilter.length == 2 ? this.dateFilter[0] : null,
        end: this.dateFilter.length == 2 ? this.dateFilter[1] : null,
        no: no,
        id: this.initFilterForm.id
      };
      let { data } = await window.instance.post(
        openSurveyReqUrl + "statistic/detail",
        ruleForm
      );
      this.subReseller = data.data.resellers;
      this.clickLabel = label;
      this.clickSum = count;
      this.showFlag = true;
    },
    onSearchDetail: async function() {
      let ruleForm = {
        posIds: this.posIds,
        questions: this.questions,
        ...this.form.filter,
        start: this.dateFilter.length == 2 ? this.dateFilter[0] : null,
        end: this.dateFilter.length == 2 ? this.dateFilter[1] : null,
        id: this.initFilterForm.id
      };
      let { data } = await window.instance.post(
        openSurveyReqUrl + "statistic/default",
        ruleForm
      );

      data.data.forEach(d => {
        d.chartType = 1;
        d.displayType = 1;
      });
      data.data.filter(l => l.type == 4).forEach(item => {
        item.items.map((item2, index) => {
          item2.sort = index + 1;
        });
      });
      this.statisticList = data.data;
      this.$nextTick(() => {
        this.statisticList.filter(l => l.type <= 3).forEach(item => {
          let target = _.cloneDeep(item.items);
          let items = target.map(d => {
            d.percent = Number(d.percent.replace("%", "")) / 100;
            return d;
          });
          this.renderCake("chart" + item.id, items, "percent");
          // this.renderBar('chart' + item.id, item.items)
        });
      });
    },
    onSearchCompare: async function() {
      let ruleForm = {
        doors: this.doors,
        ...this.compareForm,
        start: this.dateFilter.length == 2 ? this.dateFilter[0] : null,
        end: this.dateFilter.length == 2 ? this.dateFilter[1] : null,
        id: this.initFilterForm.id
      };
      let { data } = await window.instance.post(
        openSurveyReqUrl + "statistic/compare",
        ruleForm
      );

      data.data.forEach(d => {
        d.chartType = 1;
        d.displayType = 1;
      });
      this.extendItem = data.data[0].defaultItems;
      this.compareData = data.data;

      // console.log(this.compareData)
      this.$nextTick(() => {
        let temp = _.cloneDeep(this.compareData);
        let items = temp.map(d => {
          let target = { content: d.content };
          d.chatType = 1;
          d.displayType = 1;

          d.defaultItems.forEach(di => {
            target[di.content] = _.round(Number(di.percent.replace("%", "")) / 100,3);
          });
          return target;
        });
        // console.log(items)
        if(this.chartStorage["compareChart"]){
          this.chartStorage["compareChart"].destroy();
          this.chartStorage["compareChart"] = null;
        }
        this.renderRowBar("compareChart", items, "percent");
      });
    },
    onDialogSearch: async function(item) {
      if (item) {
        this.dialogType = item.type === 5 ? 1 : 2;
        this.dialogTitle = item.type === 5 ? "查看详细信息" : "查看全部";
        this.questionId = item.id;
        this.questionTitle = item.sort + "." + item.name;
      }
      let ruleForm = {
        ...this.form.filter,
        posIds: this.posIds,
        start: this.dateFilter.length == 2 ? this.dateFilter[0] : null,
        end: this.dateFilter.length == 2 ? this.dateFilter[1] : null,
        id: this.initFilterForm.id,
        questionId: this.questionId,
        page: this.table.page,
        size: this.table.size
      };
      console.log(this.dialogType);
      let { data } = await window.instance.post(
        openSurveyReqUrl +
          (this.dialogType === 2
            ? "statistic/inputCollection"
            : "statistic/doorCollection"),
        ruleForm
      );
      this.tableData = data.data.list.map((item, index) => {
        return { ...item, sort: index + 1 };
      });
      // console.log(this.tableData)
      this.table.total = data.data.total;
      this.showDialogFlag = true;
    },
    currentChange: function(index) {
      this.table.page = index;
      this.onDialogSearch();
    },
    backList: function() {
      let query = {};
      if (this.initFilterForm.date) {
        query.startTime = this.initFilterForm.date[0];
        query.endTime = this.initFilterForm.date[1];
      }
      localStorage.setItem("detailParams", JSON.stringify(query));
      //   this.$router.push({path:"/statisticList",query})
      this.$router.back();
    },
    onChooseDoor: function() {
      this.$refs.PickDoor.openDialog();
    },
    resetFilters: async function(flag) {
      let ruleForm = {
        ...this.form.filter,
        start: this.dateFilter.length == 2 ? this.dateFilter[0] : null,
        end: this.dateFilter.length == 2 ? this.dateFilter[1] : null,
        id: this.initFilterForm.id
      };
      let res = await window.instance.post(
        openSurveyReqUrl + "condition/statisticFilters",
        ruleForm
      );
      res = res.data;
      if (res.code === 200) {
        if (this.options.questions.length == 0 || flag) {
          res.data.questions.forEach(q => {
            this.$set(this.questions, q.id, {
              itemId: [],
              score: []
            });
          });
        }

        this.options = res.data;
      }
      if (flag) {
        this.compareForm.elementX = null
        this.compareForm.elementY = null
        this.form.filter = {
          regionNos: [],
          provinceNos: [],
          cityNos: [],
          resellerNos: []
        };
        this.form.posIdStr = "";
        this.$nextTick(() => {
        this.$refs.PickDoor.clearSearchKey()
        })
        res.data.questions.forEach(q => {
          this.$set(this.questions, q.id, {
            itemId: [],
            score: []
          });
        });
      }
    },
    renderDefault(item, chartType, displayType) {
      item.chartType = chartType;
      item.displayType = displayType;
      let field = displayType == 1 ? "percent" : "count";

      let target = _.cloneDeep(item.items);
      let items = target.map(d => {
        d.percent = Number(d.percent.replace("%", "")) / 100;
        return d;
      });
      this.chartStorage["chart" + item.id].destroy();
      this.chartStorage["chart" + item.id] = null;
      this.$nextTick(() => {
        if (chartType == 1) {
          this.renderCake("chart" + item.id, items, field);
        } else {
          this.renderBar("chart" + item.id, items, field);
        }
      });
    },
    renderCompare(displayType) {
      let temp = _.cloneDeep(this.compareData);
      let items = temp.map(d => {
        let target = { content: d.content };
        d.chatType = 1;
        d.displayType = displayType;

        d.defaultItems.forEach(di => {
          target[di.content] =
            displayType == 1
              ? _.round(Number(di.percent.replace("%", "")) / 100,3)
              : di.count;
        });
        return target;
      });
      this.chartStorage["compareChart"].destroy();
      this.chartStorage["compareChart"] = null;
      let field = displayType == 1 ? "percent" : "count";
      this.$nextTick(() => {
        this.renderRowBar("compareChart", items, field);
      });
    },
    renderCake(container, data, field) {
      if (!this.chartStorage[container]) {
        // let width = document.getElementById(container).offsetWidth;
        let height = document.getElementById(container).offsetHeight;
        this.chartStorage[container] = new Chart({
          container: container,
          // autoFit: true,
          appendPadding: [30, 0, 40, 0],
          width: height+400,
          height,
          // defaultColor : "#67c23a"
        });
      }
      this.chartStorage[container].coordinate("theta", {
        radius: 0.75
      });

      this.chartStorage[container].data(data);

      this.chartStorage[container].scale(field, {
        formatter: val => {
          val = val * 100 + "%";
          return val;
        }
      });

      this.chartStorage[container].tooltip({
        showTitle: false,
        showMarkers: false
      });

      this.chartStorage[container]
        .interval()
        .adjust("stack")
        .position(field)
        .color("content")
        .label(field, {
          offset: "30%",
          style: {
            textAlign: "center",
            fontSize: 14,
            shadowBlur: 2,
            shadowColor: "rgba(0, 0, 0, .45)"
          },
          layout: [{ type: 'pie-spider' }, { type: 'limit-in-plot', cfg: { action: 'ellipsis'/** 或 translate */ } }, ],
          position: "outside",
          content: obj => {
            return (
              (field == "percent" ? _.round(obj[field] * 100, 2) : obj[field]) +
              (field == "percent" ? "%" : "")
            );
          }
        })
        .tooltip("content*" + field, (content, value) => {
          value = field == "percent" ? _.round(value * 100, 2) + "%" : value;
          return {
            name: content,
            value: value
          };
        });
      // this.chartStorage[container].theme({ "styleSheet": { "brandColor": "#F4A460", "paletteQualitative10": ["#F4A460", "#F5DEB3", "#F5F5DC", "#F5F5F5", "#FFF0F5", "#FAEBD7", "#FFDAB9", "#FFE4B5", "#FFE4E1", "#FFFACD"]} });
      this.chartStorage[container].legend(true); // 关闭下面的标示行
      this.chartStorage[container].legend({ position: "right", itemHeight:16, style:{ fontSize:16 }});
      this.chartStorage[container].interaction("element-active");
      this.chartStorage[container].render();
    },

    renderBar(container, data, field) {
      if (!this.chartStorage[container]) {
        let em = document.getElementById(container);
        console.log(data.length);
        let width = data.length * 40 + 240;
        // width = width<250?250:width;
        em.style.width = width;
        // let width = document.getElementById(container).offsetWidth;
        let height = document.getElementById(container).offsetHeight;
        this.chartStorage[container] = new Chart({
          container: container,
          // autoFit: true,
          appendPadding: [50, 50, 50, 50],
          width,
          height,
          // defaultColor : "#67c23a"
        });
      }
      this.chartStorage[container].data(data);
      this.chartStorage[container].scale(field, {
        nice: true
      });
      this.chartStorage[container].tooltip({
        showMarkers: false,
        shared: true
      });

      this.chartStorage[container].axis("content",{
        label:{
          autoHide: true,
          autoRotate: false
        }
      })
      this.chartStorage[container]
        .interval()
        .position("content*" + field)
        .color("content")
        .adjust("stack")
        .label(field, {
          position: "outside",
          style: {
            textAlign: "center",
            fontSize: 14,
            shadowBlur: 2,
            shadowColor: "rgba(0, 0, 0, .45)"
          },
          content: originData => {
            // console.log('originData', originData)
            return field == "percent"
              ? _.round(originData[field] * 100, 2) + "%"
              : originData[field];
          },
          offset: 10
        })
        .tooltip("content*" + field, (content, value) => {
          value = field == "percent" ? _.round(value * 100, 2) + "%" : value;
          return {
            name: content,
            value: value
          };
        });
      this.chartStorage[container].axis(field, false);
      this.chartStorage[container].interaction("active-region");
      this.chartStorage[container].theme({ brandColor:"#67c23a"});
      this.chartStorage[container].legend({flipPage: true});      
      this.chartStorage[container].render();
    },

    renderRowBar(container, data, field) {
      if (!this.chartStorage[container]) {
        let em = document.getElementById(container);
        console.log(data.length);
        let height = data.length * 40 + 200;
        em.style.height = height;
        let width = document.getElementById(container).offsetWidth;
        // console.log(width, height)
        this.chartStorage[container] = new Chart({
          container: container,
          autoFit: true,
          width,
          height: height - 50,
          appendPadding: [50, 50, 50, 50],
          // defaultColor : "#67c23a"
        });
      }

      let ds = new DataSet();
      let dv = ds.createView().source(data);
      let fields = Object.keys(data[0]).filter(d => d != "content");
      dv.transform({
        type: "fold",
        fields: fields, // 展开字段集
        key: "选项", // key字段
        value: "数量", // value字段
        retains: ["content"] // 保留字段集，默认为除fields以外的所有字段
      });
      console.log("data", dv.rows);
      this.chartStorage[container].data(dv.rows);
      if (field == "percent") {
        this.chartStorage[container].scale("数量", {
          min: 0,
        });
      }else{
        this.chartStorage[container].scale("数量", {
          nice: true
        });
      }
      this.chartStorage[container].coordinate().transpose();
      // this.chartStorage[container].tooltip(false);
      this.chartStorage[container].axis("content", {
        grid: null
      });

      this.chartStorage[container].axis("数量",false)
      this.chartStorage[container].axis("数量", {
        label: {
          formatter: (text, item, index) => {
            // console.log("text", text);
            // console.log("item", item);
            // console.log("index", index);
            // item.name =
            return field == "percent"
              ? "" //_.round(item.value * 100, 2) + "%"
              : item.name;
          }
        }
      });
      // this.chartStorage[container]
      this.chartStorage[container].interaction("active-region");
      this.chartStorage[container]
        .interval()
        .adjust("stack")
        .position("content*数量")
        .color("选项")
        .label("数量", {
          position: "outside",
          style: {
            fill: "black",
            textAlign: "center",
            fontSize: 14,
            shadowBlur: 2,
            shadowColor: "rgba(255, 255, 255, .45)"
          },
          content: obj => {
            // console.log('originData', originData)
            return (
              (field == "percent"
                ? _.round(obj["数量"] * 100, 2)
                : obj["数量"]) + (field == "percent" ? "%" : "")
            );
          },
          offset: 10
        })
        .tooltip("content*数量", (content, value) => {
          value = field == "percent" ? _.round(value * 100, 2) + "%" : value;
          return {
            name: content,
            value: value
          };
        });
      // chart.theme({ "styleSheet": { "brandColor": "#9DF5CA", "paletteQualitative10": ["#9DF5CA", "#61DDAA", "#42C090", "#19A576", "#008A5D", "#006F45", "#00562F", "#003E19", "#002800"], "paletteQualitative20": ["#9DF5CA", "#61DDAA", "#42C090", "#19A576", "#008A5D", "#006F45", "#00562F", "#003E19", "#002800"] } });
      this.chartStorage[container].legend({ flipPage: true,itemHeight: 40 });
      this.chartStorage[container].render();
    }
  }
};
</script>
<style>
.el-dialog__body .box-item {
  position: relative;
  min-height: 160px;
  text-align: center;
}

.el-dialog__body .box-item .box-count {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 125px;
  line-height: 125px;
  text-align: center;
}

.el-divider--horizontal {
  margin: 10px 0;
}

.filter-row {
  background-color: #fff0e6;
  color: #67c23a;
}


.defaultContainer .el-table .el-table__cell{
  padding: 6px 0;
}
</style>
<style scoped lang="scss">
.statisticDetail {
  .defaultContainer {
    margin-top: 30px;
  }

  .title {
    width: 100%;
    text-align: center;
    font-size: 16px;
    line-height: 28px;
    position: relative;

    .back {
      position: absolute;
      right: 20px;
    }
  }

  .box-card {
    width: calc(100% - 20px);
    box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px;
    padding: 10px;
    background-color: white;
    border-radius: 3px;
    position: relative;

    .chart-btn {
      position: absolute;
      right: 0;
      width: 144px;
      line-height: 40px;
      display: inline-flex;

      &.top {
        top: 0;
      }

      &.bottom {
        bottom: 0;
      }

      div {
        box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 12px 0px;
        width: 70px;
        text-align: center;
        cursor: pointer;
      }

      div[active="true"] {
        background-color: #fff0e6;
        color: #67c23a;
      }

      .before {
        margin-right: 1px;
      }
    }

    .box-item {
      position: relative;
      min-height: 240px;
      text-align: center;
      padding-top: 5px;

      .title {
        position: absolute;
        width: fit-content;
        left: 5px;
      }

      .box-count {
        position: absolute;
        top: 30px;
        width: 100%;
        height: 135px;
        line-height: 135px;
        text-align: center;
      }

      &.first {
        border-right: 1px solid #f1f1f1;

        .box-count {
          font-size: 24px;
          font-weight: 600;
        }
      }

      &.last {
        border-left: 1px solid #f1f1f1;

        .box-count {
          font-size: 24px;
          font-weight: 600;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/openSurvey/pages/StatisticDetail.vue